import React, { useEffect } from 'react'
import { useProperty } from '../context/PropertyContext.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Housestyle from '../assets/house-style.png';
import { useState } from 'react'
import Pagination from './Pagination.js';
import Pricerange from '../assets/price-range.png'
import { useNotification } from '../context/NotificationContext.js';

    function formatDate(isoString) {
        const date = new Date(isoString);
    
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        };
    
        return date.toLocaleString('en-US', options);
    }

    function formatWithComma(price) {
    return parseInt(price).toLocaleString('en-US');
}

function Properties() {


        const {allPropertyData, updatePropertyStatus, deleteProperty,fetchAllPropertiesPaginate, totalPages:allPages, propertyIsLoading} = useProperty();

        const {postNotification} = useNotification()
        const [searchTerm, setSearchTerm] = useState('');
        const [currentPage, setCurrentPage] = useState(1);
        const [totalPages, setTotalPages] = useState(allPages || 1);
        const [priceRange, setPriceRange] = useState('');
        const [propertyType, setPropertyType] = useState('');
        const [showPriceDropdown, setShowPriceDropdown] = useState(false);
        const [showHouseFilterDropdown, setShowHouseFilterDropdown] = useState(false);
        const limit =  9;

useEffect(() => {
    const fetchData = async () => {
        let data = {
            page: currentPage,
            limit: limit,
            search: searchTerm,
            priceRange: priceRange,
            propertyType: propertyType
        };
        await fetchAllPropertiesPaginate(data);
    };
    
    fetchData();
}, [currentPage, searchTerm, priceRange, fetchAllPropertiesPaginate, propertyType]);

    useEffect(() => {
        if(allPages){
            setTotalPages(allPages)
        }
    }, [allPages]);

          const handlePriceRangeSelect = (range) => {
        setPriceRange(range);
        setCurrentPage(1); 
        setShowPriceDropdown(false); 
        setPropertyType('')
    }

          const handlePropertyTypeSelect = (type) => {
        setPropertyType(type);
        setCurrentPage(1); 
        setShowHouseFilterDropdown(false); 
          setPriceRange('');
    }

     const handlePageChange =  async(page) => {
       
        if (page >= 1 && page <= totalPages) {
            
                setCurrentPage(page)
            
       
            let data = {
                page: page,
                limit: limit,
                search: searchTerm,
                priceRange: priceRange,
                propertyType: propertyType
            }
                 await fetchAllPropertiesPaginate(data)
         
        }
         
    }

    async function handleDeleteUser(id) {
         await deleteProperty(id)
         
        let data = {
            page: currentPage,
            limit: limit,
            search: searchTerm,
            priceRange: priceRange,
            propertyType: propertyType
        };
        await fetchAllPropertiesPaginate(data);
        toast.success('Property deleted successfully', {position: "top-right", autoClose: 2000})
         
         
    }

const toggleKYCStatus = async (propertyId, user_id, property_name, owner_name, currentStatus) => {
    try {
        const newStatus = currentStatus === 'true' ? 'false' : 'true';
        const data = {
            status: newStatus
        }
        
        await updatePropertyStatus(propertyId,  data)
         let newData = {
            page: currentPage,
            limit: limit,
            search: searchTerm,
            priceRange: priceRange,
            propertyType: propertyType
        };
        await fetchAllPropertiesPaginate(newData);
          toast.success('Property Verification Status updated successfully', {position: "top-right", autoClose: 2000})

        if (newStatus === 'true') {
            const notifyGlobalData ={
            message:  `"New Property Alert! ${property_name} by ${owner_name} has just been approved and is now live."` ,
            type: 'global',
            user_id: user_id,
            sender_id: user_id,
            url: `/dashboard/homeproperties`
            }
            await postNotification(notifyGlobalData)
          }
            
       
    } catch (error) {
        console.error('Error updating status:', error);
    }
};

  
  return (
    <div className="homify-recommendation margin-top2 " id="recommendation">
              <ToastContainer />
                <div className="recommendation-searchcontaiiner">
                <div className="recommendation-search">
                    <input 
                        type="text" 
                        placeholder="search name, location, description" 
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);  // Reset to first page on new search
                        }}
                    />
                    <button type="button" onClick={() => setCurrentPage(1)}>Search</button>
                </div>

                <div className="recommendation-filter">
                    <div className='house-filter-container'>
                        <div className="house-filter" onClick={() => setShowHouseFilterDropdown(!showHouseFilterDropdown)}>
                            <img src={Housestyle} alt="house-icon" />
                            <p>Property Type</p>
                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.24995 3.90002L6.49995 7.15002L9.74995 3.90002L11.05 4.55002L6.49995 9.10002L1.94995 4.55002L3.24995 3.90002Z" fill="#00985B"/>
                            </svg>
                        </div>
                        {showHouseFilterDropdown && (
                            <div className="house-filter-dropdown">
                                <button className='price-button' onClick={() => handlePropertyTypeSelect("Residential Building")}>Residential Building</button>
                                <button className='price-button' onClick={() => handlePropertyTypeSelect("Commercial Building")}>Commercial Building</button>
                                <button className='price-button' onClick={() => handlePropertyTypeSelect("Land")}>Land</button>
                       
                            </div>
                        )}
                    </div>
                    
                    <div>
                        <div className='price-container'>
                            <div className="house-filter" onClick={() => setShowPriceDropdown(!showPriceDropdown)}>
                                <img src={Pricerange} alt="house-icon" />
                                <p>Price Range</p>
                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.24995 3.90002L6.49995 7.15002L9.74995 3.90002L11.05 4.55002L6.49995 9.10002L1.94995 4.55002L3.24995 3.90002Z" fill="#00985B"/>
                                </svg>   
                        
                            </div>
                            {showPriceDropdown && (
                                    <div className="price-dropdown">
                                        <button className='price-button' onClick={() => handlePriceRangeSelect("0-20000000")}>₦0 - ₦20,000,000</button>
                                        <button className='price-button' onClick={() => handlePriceRangeSelect("20000000-50000000")}>₦20,000,000 - ₦50,000,000</button>
                                        <button className='price-button' onClick={() => handlePriceRangeSelect("50000000-100000000")}>₦50,000,000 - ₦100,000,000</button>
                                        <button className='price-button' onClick={() => handlePriceRangeSelect("100000000-1000000000")}>₦100,000,000 - ₦1,000,000,000</button>
                                    </div>
                            )}
                        </div>
                    </div>
      
           
                </div>
            </div>

        <div className="admin-section">
            <h2 className='admin-category'>Properties</h2>
            <table className='admin-table'>
                <thead className='thread'>
                    <tr className='tr'>
                      <th className='th'>SN</th>
                      <th className='th'>Owner</th>
                      <th className='th'>Property Name</th>
                      <th className='th'>Location</th>
                      <th className='th'>Transaction</th>
                      <th className='th'>Property Type</th>
                      <th className='th'>Property Price</th>
                      <th className='th'>Property Description</th>
                      <th className='th'>Date Uploaded</th>
                      <th className='th'>Verification Status</th>
                      <th className='th'>Option</th>
                    </tr>
                </thead>
                <tbody className='tbody'>
                             { allPropertyData.map((property, index) => (
                        <tr className='tr' key={property.id}>
                            <td className='td'>{index + 1}</td>
                            <td className='td'>{property.user_name}</td>
                            <td className='td'>{property.name_of_property}</td>
                            <td className='td'>{property.address}</td>
                            <td className='td'>{property.transaction}</td>
                            <td className='td'>{property.type_of_property}</td>
                            <td className='td'>N{formatWithComma(property.price)}</td>
                            <td className='td'>{property.description}</td>
                            <td className='td'>{formatDate(property.date_uploaded)}</td>
                            <td className='td'>
                                <label className="switch">
                                <input 
                                    type="checkbox" 
                                    checked={property.status === 'true'} 
                                    onChange={() => toggleKYCStatus(property.id, property.user_id, property.name_of_property, property.user_name, property.status)} 
                                />
                                <span className="slider"></span>
                                </label>
                            </td>
                            <td className='td'><span onClick={() => handleDeleteUser(property.id)} className='upload-document-red'>Delete</span></td>
                        </tr>
                    ))
              }
                </tbody>
            </table>
        </div>
         <Pagination
                        currentPage={currentPage} 
                        totalPages={totalPages} 
                        onPageChange={handlePageChange} 
                    />
    </div>
  )
}

export default Properties